import { useState } from "react";
import { Pause, Play } from "lucide-react";

const WORDS = [
  "Mente",
  "Corpo",
  "Emozioni",
  "Relazioni",
  "Dipendenze",
  "Fede",
  "Scopo",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {[...Array(2)].flatMap((_, r) =>
      WORDS.map((w, i) => (
        <span key={`${r}-${i}`} className="flex items-center">
          <span className="whitespace-nowrap px-6 text-[10px] sm:text-[11px] font-semibold uppercase tracking-[0.28em] text-white">
            {w}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 bg-gold" aria-hidden />
        </span>
      ))
    )}
  </div>
);

export const TopMarquee = () => {
  const [paused, setPaused] = useState(false);

  return (
    <div
      className={`marquee-track relative flex items-center overflow-hidden border-b border-gold/25 bg-black py-2.5 shadow-[0_1px_12px_rgba(255,211,77,0.12)] ${paused ? "marquee-paused" : ""}`}
      data-testid="top-marquee"
      aria-label="Temi del percorso Tempio Vivo"
    >
      <div className="flex w-max animate-marquee [animation-duration:90s]">
        <Row />
        <Row />
      </div>
      <button
        onClick={() => setPaused((p) => !p)}
        data-testid="marquee-pause-button"
        aria-label={paused ? "Riprendi scorrimento" : "Metti in pausa lo scorrimento"}
        className="absolute right-2 top-1/2 flex h-6 w-6 -translate-y-1/2 items-center justify-center rounded-full border border-gold/40 bg-black/80 text-gold transition-colors duration-300 hover:bg-gold hover:text-black"
      >
        {paused ? <Play className="h-3 w-3" /> : <Pause className="h-3 w-3" />}
      </button>
    </div>
  );
};
